module.exports = __webpack_public_path__ + "static/media/occasions-service-guarantee.2fe0194c.jpg";